function addtocartHandler(event) {
    // ここで実際にショッピングカートに商品を追加して更新する処理を実装する
    console.log('addtocart event', event);

    const productId = event.productId;
    const variantId = event.variantId.split('/').pop();
    const quantity = event.quantity;
    console.log([variantId, quantity]);

    const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];

    const formData = new FormData(this.form);
    if (cart) {
        formData.append(
            'sections',
            cart.getSectionsToRender().map((section) => section.id),
        );
        formData.append('sections_url', window.location.pathname);
        cart.setActiveElement(document.activeElement);
    }
    formData.append('form_type', 'product');
    formData.append('product-id', productId);
    formData.append('id', variantId);
    formData.append('quantity', quantity);
    config.body = formData;

    fetch(`${routes.cart_add_url}`, config)
        .then((response) => {
            return response.json().then((data) => {
                if (!response.ok) {
                    // エラーメッセージを表示する準備
                    throw new Error(data.message || 'カートに追加できませんでした');
                }
                return data;
            });
        })
        .then((response) => {
            console.log(`cart/add response`, response);

            cart.renderContents(response);
            // cart-drawerの場合、is-emptyをはずす
            if (document.querySelector('.cart-drawer')) {
	              cart.classList.remove('is-empty');
            }
            cart.open();
        })
        .catch((error) => {
            console.error('Error:', error);
            alert(error.message);
        });
}
